import { BOARD_MESSAGE_CONSTANT } from '../constants/MessageConstants';

 /* istanbul ignore next */
export const initMessageComp = () => {
    return dispatch => {
        //reducer funct pupulate
        dispatch( {
            type: BOARD_MESSAGE_CONSTANT.INIT_MESSAGE
        } )
     }
}

export const showMessage = config => {
    return {
        type: BOARD_MESSAGE_CONSTANT.SHOW_MESSAGE,
        config
    }
}

export const hideMessage = config => {
    return {
        type: BOARD_MESSAGE_CONSTANT.HIDE_MESSAGE,
        config
    }
}